import { Directive } from '@angular/core';

@Directive({
    selector: '[appDialogBody]',
    standalone: false
})
export class DialogBodyDirective {}
